import React from 'react'
import classNames from 'classnames';
import {MapPinIcon} from '@heroicons/react/24/solid';
import Header1 from '../assets/images/HeaderImg-1.jpg';
import Header2 from '../assets/images/HeaderImg-2.jpg';
import Header3 from '../assets/images/HeaderImg-3.jpg';


import {
  CalendarDaysIcon, 
  ClockIcon,
  CheckCircleIcon
} from '@heroicons/react/24/solid'


const details = [
  {
    header: "Services", 
    headerImg: Header2,
    bullets: [
      {text: "1 on 1 coaching from former proffessional soccer players", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Technical training with a focus on dribbling, shooting, and passing", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Small sided games/tournaments", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Camp vs Counselor Games", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
    ],
    last: false
  },
  {
    header: "Logistics",
    headerImg: Header1,
    bullets: [
      {text: "Location: 1220 River Rd, New Castle, DE 19720", icon: <MapPinIcon className="w-6 inline mr-3"/>},
      {text: "Dates: Dec 27, - Dec 29, 2023", icon: <CalendarDaysIcon className="w-6 inline mr-3"/>},
      {text: "Pre-Care Hours: 7:00AM to 9:00AM", icon: <ClockIcon className="w-6 inline mr-3"/>},
      {text: "Regular Camp Hours: 9:00AM to 3:00PM", icon: <ClockIcon className="w-6 inline mr-3"/>},
      {text: "After-Care Hours: 3:00PM to 5:00PM", icon: <ClockIcon className="w-6 inline mr-3"/>},
    ],
    last: false
  },
  {
    header: "What to Bring",
    headerImg: Header3, 
    bullets: [
      {text: "Water and sports drinks will be provided!", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Cleats / Shinguards", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Lunch", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
      {text: "Sunscreen", icon: <CheckCircleIcon className="w-6 inline mr-3"/>},
    ],
    last: true
  },
]


export function Card({info}) {
  const bullets = info.bullets.map((bullet, index) => {
    return (
      <div className="flex items-center mb-3" key={index}>
        <div>{bullet.icon}</div>
        <p className='inline text-sm'>{bullet.text}</p>
      </div>
    )
  })
  
  return (
    <div className={classNames("detail card", {
      "md:col-start-4 lg:col-start-auto": info.last
    })}>
      
      <img src={info.headerImg} alt="soccer-camp" className="w-full h-48 lg:h-64 object-cover"/>
     
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="mb-3">{info.header}</h3>
        <div className="bg-opacity-10  w-full flex-grow flex justify-between flex-col">
          {bullets}
        </div>
      </div>
    </div>
  )
}

export default function CampDetails() {

  return (
    <div id="details" className="text-white w-full mt-10 container-padding scroll-m-16">
      <div className="flex flex-col mb-6">
        <h1 className="font-bold tracking-tight sm:text-6xl mb-3 text-center">
          2023 Camp Details
        </h1>
        <p className="bg-opacity-10 rounded-lg mb-10 w-full lg:w-4/5 text-center mx-auto">
          SelectFut Camp is a 3 day 9-3 soccer camp ranging from ages u7-u15. 
          The primary focus will be on individual development to establish a love for the game through technical training. 
          We want to provide a holistic approach to player development by giving players a unique experience run by former 
          professionals. 
        </p>
      </div>
      
      <div className="grid grid-cols-12 w-full gap-2 mb-3">
        <Card info={details[0]}/>
        <Card info={details[1]}/>
        <Card info={details[2]}/>
      </div>

    </div>
  )
}



